import { Tab, Tabs } from '@mui/material';
import { styled } from '@mui/material/styles';

const MapContainer = styled('div')`
	width: 100%;
	height: ${(props) => (props.height ? props.height : '400px')};
`;

const LocationSearchTabs = styled(Tabs)({
	indicator: {
		backgroundColor: '#DC5C87',
	},
});

const LocationSearchTab = styled(Tab)({
	textColorPrimary: {
		color: '#878E88',
	},
	selected: {
		color: '#070707',
	},
});

const LocationSearchBody = styled('div')`
`;

export { MapContainer, LocationSearchTabs, LocationSearchTab, LocationSearchBody };
